import * as THREE from 'three';
export default class BakedModel {
    constructor(model, texture, scale) {
        this.model = model;
        // Escala y posición del modelo
        this.model.scene.scale.set(scale, scale, scale);
        this.model.scene.position.y = -2570;
        this.model.scene.position.z = 1300;
        this.model.scene.rotation.x = -0.1; // inclinar hacia abajo
        // Reemplazar materiales por MeshBasicMaterial, conservando todas las texturas
        this.model.scene.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                const oldMat = child.material;
                const newMat = new THREE.MeshBasicMaterial({
                    map: oldMat.map || null,
                    color: oldMat.color || new THREE.Color(0xffffff),
                    transparent: oldMat.transparent,
                    opacity: oldMat.opacity,
                });
                // Copiar otras texturas si existen
                if (oldMat.emissiveMap)
                    newMat.map = oldMat.emissiveMap;
                if (oldMat.alphaMap)
                    newMat.alphaMap = oldMat.alphaMap;
                if (oldMat.lightMap)
                    newMat.lightMap = oldMat.lightMap;
                // Ajustar encoding y orientación
                if (newMat.map) {
                    newMat.map.flipY = false;
                    newMat.map.encoding = THREE.sRGBEncoding;
                }
                child.material = newMat;
            }
        });
        return this;
    }
    getModel() {
        return this.model.scene;
    }
}
